import { Slide } from 'yet-another-react-lightbox';

import { Media, MediaType } from '@atom/types/media';
import {
  mediaFileName,
  mediaStreamUrl,
  mediaUrl,
  MediaWidth,
} from '@atom/utilities/mediaUtilities';

import 'yet-another-react-lightbox/plugins/video';

const SLIDE_WIDTH: MediaWidth = 1440;
const SRC_SET_WIDTHS: MediaWidth[] = [180, 1440];

const VIDEO_MIME_TYPES: Record<string, string> = {
  '3gp': 'video/3gpp',
  avi: 'video/x-msvideo',
  m4v: 'video/x-m4v',
  mkv: 'video/x-matroska',
  // Chrome skips a source typed video/quicktime, but plays the same file as video/mp4
  mov: 'video/mp4',
  mp4: 'video/mp4',
  mpeg: 'video/mpeg',
  mpg: 'video/mpeg',
  ogg: 'video/ogg',
  ogv: 'video/ogg',
  webm: 'video/webm',
};

const DEFAULT_VIDEO_MIME_TYPE = 'video/mp4';

export const videoMimeType = (fileExtension: string): string =>
  VIDEO_MIME_TYPES[(fileExtension || '').toLowerCase()] ||
  DEFAULT_VIDEO_MIME_TYPE;

const toImageSlide = (media: Media): Slide => ({
  type: 'image',
  src: mediaUrl(media.fileId, SLIDE_WIDTH),
  alt: mediaFileName(media),
  srcSet: SRC_SET_WIDTHS.map(width => ({
    src: mediaUrl(media.fileId, width),
    width,
    height: width,
  })),
});

const toVideoSlide = (media: Media): Slide => ({
  type: 'video',
  autoPlay: true,
  sources: [
    {
      src: mediaStreamUrl(media.fileId),
      type: videoMimeType(media.fileExtension),
    },
  ],
});

export const toSlides = (media: Media[]): Slide[] =>
  media.map(medium =>
    medium.type === MediaType.VIDEO
      ? toVideoSlide(medium)
      : toImageSlide(medium),
  );
